<template>
  <div>
    <Header />

    <!-- <Hero headline="Resume" /> -->
    <section class="resume">
      <div class="content">
        <ResumeNav />
        <router-view />
        <!-- <About />
        <Skills />
        <WorkHistory /> -->
      </div>
    </section>
    <ResumeFooter />
  </div>
</template>

<script>
  import Header from "@/components/Header.vue"
  import Hero from "@/components/Hero.vue"
  import ResumeNav from "@/components/resume/ResumeNav.vue"
  import ResumeFooter from "@/components/resume/ResumeFooter.vue"
  import About from "@/components/resume/About.vue"
  import Skills from "@/components/resume/Skills.vue"
  import WorkHistory from "@/components/resume/WorkHistory.vue"
  import Contact from "@/components/resume/Contact.vue"

  // import anime from "animejs"
  export default {
    name: "Resume",
    components: {
      Header,
      Hero,
      ResumeNav,
      ResumeFooter,
      About,
      Skills,
      WorkHistory,
      Contact,
    },
    data() {
      return {
        headline: "Why are you here?",
      }
    },
  }
</script>

<style lang="scss">
  @import "./src/scss/style--light";
</style>
